import { TooltipPosition } from "@angular/material/tooltip";
import { IActionMan } from "../http/modules/get.model";

export enum Permission {
  Aprove = 1,
  Create = 2,
  Edit = 3,
  Delete = 4,
  Read = 5,
  Execute = 6
}

export const PERMISSIONS = [
  Permission.Aprove,
  Permission.Create,
  Permission.Edit,
  Permission.Delete,
  Permission.Read,
  Permission.Execute,
]

export const ACTIONS = [
  { id: Permission.Aprove,  descripcion: "Aprobar"  },
  { id: Permission.Create,  descripcion: "Crear"  },
  { id: Permission.Edit,  descripcion: "Editar"  },
  { id: Permission.Delete,  descripcion: "Eliminar"  },
  { id: Permission.Read,  descripcion: "Lectura"  },
  { id: Permission.Execute,  descripcion: "Ejecutar"  },
]

export enum TypeCell {
  Checkbox = 'checkbox', // selecciona y cambia el permiso


  Button = 'button', // boton normal
  ButtonRoute = 'button-route', // boton para ver el link de servicios y submodulos
  Chips = 'chips', // muesta los valores que el nodo contiene actualmente
  Icon = 'icon',  // para usarse como icono o boton
  IndividualCheckbox = 'individual-checkbox', // para seleccionar la fila solamente
  Input = 'input', // inputs
  OnlyInput = 'only-input', // only input
  PartialCheckbox = 'partial-checkbox', // si alguno checkbox hijo esta seleccionado propaga al padre para decirle que hay algo
  PropagateCheckbox = 'propagate-checkbox', // activa todos los tipo checkbox adyacentes e hijos y agrega su valor al arreglo
  Switch = 'switch', // activa o desactiva algo como el individual checkbox
  Title = 'title', // para texto, los hijos se van a acomodar un espacio a la izquierda para indicar jerarquia
}

export enum ShowCellIn {
  All,
  Leaves,
  Nodes,
  NotRoot,
  OnlyRootAndLeaves,
  Root
}

export enum StatusActiveChildren {
  None,
  Some,
  All
}

export interface ITreeStructure {
  id: string | undefined;
  length: number;
  values: any[]
  headers: IHeader[];
  items: ITree[];
  isActiveForPropagate?: boolean;
  enableChecks?: boolean;
}

export interface IHeader {
  title: string;  // titulo del header
  type: TypeCell; // tipo de celda
  value?: any; // valor de la columna (usado para permisos o lo que se necesite)
  hiddenHeader?: boolean; //mostrar fila de headers
  showCellIn?: ShowCellIn; // mostrar input o info solo en determinadas celdas, sino se manda por default se muestra en todas
  enableMiniCard?: boolean; // habilitar minicard
  icon?: string; // icono
  icon_svg?: string; // icono svg
  canDisableIt?: boolean; // se puede deshabilitar la celda
  treeAction?: TreeAction // action del input (sobre escribe el comportamiento de los checks)
  toolTipText?: string; // texto
  toolTipAlign?: TooltipPosition;
  headerActions?: IHeader; // header del header
  isEditable?: boolean; // solo usado en typeInput, para editar su texto
  placeholder?: string; //usado en los typeInput para headerActions
}

export interface ITree {
  title: string;  //  titulo del nivel
  isActive: boolean; // nodo activo
  isActiveInFilter: boolean; // activo en filtros
  statusActiveChildren: StatusActiveChildren; // Estado de hijos checked
  values: any[]; // permisos
  children: ITree[]; // hijos
  filteredChildren: ITree[],
  status?: "new" | "current";
  id?: string | number; // id de base de datos
  uuid?: string; // id de nodo
  isDisable?: boolean; // esta deshabilitado
  route?: string;
  actions?: IActionMan[],
  isExternal?: boolean;
  notServices?:  boolean;
  forceOnlyRead?: boolean;
}

export enum TreeAction {
  Add = "add" ,
  Edit = "edit" ,
  Delete = "delete" ,
  Delete_Physical = "delete_physical",
  Get = "get" ,
  Show = "show",
  All = "all"
}
export interface ISignalBtn {
  id: string | undefined;
  treeAction: TreeAction;
  header?: IHeader;
  item?: ITree;
  parent?: ITree;
  additionalProps: IAdditionalProps;
}


export interface IAdditionalProps{
  level?: number;
  inputValue?: string;
  treeAction?: TreeAction;
  isChecked?: boolean;
  action?: IActionMan
}
